import { render, staticRenderFns } from "./selected-package-infos.vue?vue&type=template&id=048f20c6&"
import script from "./selected-package-infos.vue?vue&type=script&lang=js&"
export * from "./selected-package-infos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports